export default __webpack_public_path__ + "static/media/cerebro.0de0279f.svg";